import type * as React from 'react';

import type { MarkProps } from '@gitbook/slate-react';

export function MarkSuperscript(props: MarkProps): React.ReactElement {
    const { children, attributes } = props;
    return <sup {...attributes}>{children}</sup>;
}
